import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What does a healthcare software developer do?",
    answer: `<p>These engineers create software programs or systems that make healthcare services easier to access and offer innovative approaches to providing medical treatments with modern technology.</p>`,
  },
  {
    question: "How much does healthcare software development cost?",
    answer: `<p>The average expenses in developing a healthcare app with many features are around $40,000. The price range may increase/decrease due to a number of factors that involve the type of the platform, level of the developers skill, experience, and the level of complexity of the medical app.</p>`,
  },
  {
    question: "What software does the healthcare industry use?",
    answer: `<p>The healthcare industry usually uses (EHR) electronic health record software that is widely deployed by clinics and hospitals. This application is very much like the common CRM (Customer Relationship Management) product, but it has been particularly tailored to the requirements of the medical world.</p>`,
  },
  {
    question: "What is custom healthcare software development?",
    answer: `<p>Healthcare software development refers to the ideas and management of new software that can only be applied in the healthcare industry.</p><p>Our custom healthcare software development services are designed to support patient care, reduce administrative burdens, and improve care workflow efficiency in the healthcare sector.</p>`,
  },
  {
    question: "What is the most popular software in healthcare?",
    answer: `<p>Healthcare professionals most likely rely on electronic health record software, which is the most wide-spread software in this industry. It is a digital version of a patient’s medical file that records all of his/her personal data including present day medications, past treatments, and other things.</p>`,
  },
  {
    question:
      "Are your healthcare software services aligned with HIPAA compliance standards?",
    answer: `<p>Yes, we maintain the highest standards of quality and security during the healthcare software development process, and we follow HIPAA best practices.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Healthcare Software Solution FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
